<template>
  <div class="wrapper">
    <div class="header">
    </div>
    <div class="content">
      <div class="content-left">
        <a-tree-select
          show-search
          tree-node-filter-prop="title"
          v-model="selectNode"
          style="width: 100%"
          :tree-data="treeData"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :placeholder="$t('common_please_input') + $t('page_transport_select_group_menu')"
          tree-default-expand-all
          @select="selectGroup"
        ></a-tree-select>
        <div class="device-wrapper" ref="container">
          <div
            v-for="(item, index) in groupList"
            :key="item.id + item.resourceDisplayName"
            v-dropbale="(meta) => onDrop(item, meta)"
            @dragenter="(e) => hightLight(e, index, true)"
            @dragleave="(e) => hightLight(e, index, false)"
            @drop="(e) => hightLight(e, index, false)"
            @click="changeDirectory(item)"
          >
            <div class="device" v-selected="item.id === selectDirectoryId">
              <img :src="item.picture || defaultPic" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-resize="'x'"></div>
      <div class="content-right" id="black-main">
        <a-tabs
          type="card"
          v-model="activeTab"
          style="height: 100%;background: #fff;"
          :tabBarStyle="{
            background: '#f8f8f8'
          }"
        >
          <a-radio-group
            style="margin: 0 8px"
            v-if="activeTab === '1'"
            v-model="type"
            slot="tabBarExtraContent"
          >
            <a-radio-button :value="0">
              <a-icon type="menu" />
            </a-radio-button>
            <a-radio-button :value="1">
              <a-icon type="appstore" />
            </a-radio-button>
          </a-radio-group>
          <a-tab-pane :tab="$t('page_transport_select_source_pool')" key="1">
            <div class="current-panel">
              <transport-source-or-file v-if="activeTab === '1'" type="source" :showType="type" />
            </div>
          </a-tab-pane>
          <a-tab-pane :tab="$t('page_transport_select_my_file')" key="2">
            <div class="current-panel">
              <transport-source-or-file v-if="activeTab === '2'" type="file" :showType="type" />
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <a-modal v-model="visible" :footer="null" :maskClosable="false">
      <div class="transport-modal">
        <p>{{ $t('page_transport_choose_type') }}</p>
        <div>
          <a-button style="margin-right:50px" type="primary" @click="() => runCache(1)">{{
            $t('page_transport_processing_documents')
          }}</a-button>
          <a-button type="primary" @click="() => runCache(2)">
            {{ $t('page_transport_Process_documents') }}
          </a-button>
        </div>
      </div>
    </a-modal>
    <DirectoryContent
      :visible="directoryContentVisible"
      :selectDirectory="selectDirectory"
      @close="closeDirectoryContent"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import TransportSourceOrFile from './components/TransportSourceOrFile'
import DirectoryContent from './components/DirectoryContent'

import {
  TransferDirectoryGroupServiceProxy,
  TransferDirectoryQueryServiceProxy,
  TransferDirectoryFileServiceProxy
} from '@/service-proxies/app-v2/dnc.service-proxies'
const defaultPic = require('@/assets/images/defaultDirectory.png')
const serviceProxyGroup = new TransferDirectoryGroupServiceProxy()
const serviceProxyQuery = new TransferDirectoryQueryServiceProxy()
const serviceProxyFile = new TransferDirectoryFileServiceProxy()

let cache

const mapTree = (tree) => {
  tree.forEach((t) => {
    ;(t.key = t.id), (t.value = t.id)
    if (t.children && t.children.length > 0) mapTree(t.children)
  })
}

export default Vue.extend({
  components: {
    TransportSourceOrFile,
    DirectoryContent
  },
  data() {
    return {
      visible: false,
      defaultPic: defaultPic,
      activeTab: '1',
      filter: null,
      selectNode: '0',
      treeData: [],
      groupList: [],
      tableLoading: false,
      selectDirectory: {},
      selectDirectoryId: '', // 当前选中的目录
      fileList: [],
      directoryContentVisible: false,
      type: 0
    }
  },
  mounted() {
    this.getTreeData()
    this.getTreeList()
  },
  methods: {
    hightLight(e, index, status) {
      e.preventDefault()
      const target = this.$refs.container.children[index]
      target.style.border = status ? '1px solid #4a90e2' : 'none'
    },
    runCache(...args) {
      cache(...args)
      cache = null
      this.visible = false
    },
    async onDrop(item, meta) {
      if (typeof meta === 'string' || !meta) return

      const { id, hasResource, resourceDisplayName, versionName } = item
      if (meta._type == 'source') {
        const cb = async () => {
          let fileList = meta.fileList

          fileList = fileList.map((file) => ({
            contentLength: file.contentLength,
            contentMd5: file.contentMd5,
            contentType: file.contentType,
            fileType: file.fileType,
            filename: file.displayName,
            objectKey: file.objectKey,
            suffix: file.suffix,
            transferDirectoryId: id,
            fileSource: 2,
            resourceId: meta.id,
            versionId: meta.currentVersionId,
            originalFilename: file.displayName
          }))
          await serviceProxyFile.saveResource(fileList)
          this.$message.success(this.$t('page_transport_select_save_success'))
          await this.getTreeList()
        }

        if (hasResource) {
          const content = this.$t('page_transport_sure_replace').replace(
            '${1}',
            `${resourceDisplayName}(${versionName})`
          )

          this.$confirm({
            title: `${this.$t('tips')}:`,
            content: content,
            cancelText: this.$t('cancel'),
            okText: this.$t('ok'),
            onOk() {
              cb()
            }
          })
        } else {
          cb()
        }
        return
      }

      this.visible = true
      cache = async (fileType) => {
        const data = {
          fileType,
          filename: meta.name,
          originalFilename: meta.name,
          contentLength: meta.contentLength,
          contentType: meta.contentType,
          suffix: meta.suffix,
          objectKey: meta.objectKey,
          contentMd5: meta.contentMd5,
          transferDirectoryId: id,
          fileSource: 1
        }
        await serviceProxyFile.save([data])
        this.$message.success(this.$t('page_transport_select_save_success'))
      }
    },
    async getTreeList() {
      const id = this.selectNode || '0'
      const data = await serviceProxyQuery.findTransferDirectoryList(id)
      this.groupList = data
    },
    async getTreeData() {
      const data = await serviceProxyGroup.treeList()
      mapTree(data)
      this.treeData = [
        {
          title: this.$t('page_docdirectory_manage_menu'),
          value: '0',
          children: data
        }
      ]
    },
    load() {
      console.log('1')
    },
    selectGroup() {
      this.$nextTick(() => {
        this.getTreeList()
      })
    },
    // 切换设备目录
    changeDirectory(data) {
      this.selectDirectory = data
      this.selectDirectoryId = data.id
      this.directoryContentVisible = true
    },
    closeDirectoryContent() {
      this.directoryContentVisible = false
    }
  }
})
</script>

<style scoped lang="less">
.wrapper {
  user-select: none;
  height: 100%;

  .header {
    height: 0;
    // height: 48px;

    &::after {
      content: '';
      display: table;
      clear: both;
    }

    .header-right {
      float: right;
    }
  }
  .content {
    // height: calc(100% - 48px);
    height: 100%;
    display: flex;
    align-items: stretch;

    .content-left {
      width: 300px;
      padding: 16px;
      background-color: #f8f8f8;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);

      .device-wrapper {
        display: flex;
        flex-wrap: wrap;
        margin-left: -8px;
        margin-right: -8px;
        overflow-y: auto;
        margin-top: 8px;
        height: calc(100% - 40px);
        align-content: flex-start;

        > div {
          box-sizing: border-box;
          width: 50%;
          padding: 8px;
          height: 142px;

          & > * {
            pointer-events: none;
          }
        }

        .device {
          background: #fff;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          height: 100%;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          cursor: pointer;

          &.selected {
            box-shadow: 0 0 4px 0 #4a90e2;
            border: solid 1px #4a90e2;
          }

          img {
            width: 64px;
            height: 64px;
          }

          span {
            margin-top: 5px;
          }
        }
      }
    }

    .content-right {
      position: relative;
      background: #f8f8f8;
      flex-grow: 1;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
      overflow: hidden;

      /deep/ .ant-tabs-content {
        height: calc(100% - 56px);

        .ant-tabs-tabpane-active {
          height: 100%;

          .current-panel {
            height: 100%;
          }
        }
      }

      /deep/ .ant-tabs-nav-wrap {
        background: transparent;
      }

      /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
        margin-right: 0px;
        box-sizing: border-box;
        border-left: none;
      }
    }
  }
}

.drop-wrapper {
  border: 1px dashed #4a90e2;
}

.transport-modal {
  height: 200px;
  font-size: 24px;

  p {
    padding-top: 50px;
    text-align: center;
    margin-bottom: 50px;
  }
  div {
    display: flex;
    justify-content: center;
  }
}

/deep/ .ant-tabs-nav > div {
  // display: flex;

  .ant-tabs-tab.ant-tabs-tab-active::before {
    border-top: 3px solid #4a90e2 !important;
  }
}
</style>
